/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegFlowConfig = {
    SelfInitiatedFlow: 'selfInitiatedFlow',
    SelfInitiatedFlowV2: 'selfInitiatedFlowV2',
    ShareBarFlow: 'shareBarFlow',
    CoApplicantFlow: 'coApplicantFlow',
    ManualRenewalFlow: 'manualRenewalFlow',
    UpgradeFlow: 'upgradeFlow',
    DowngradeFlow: 'downgradeFlow',
    AutoRenewSignUpFlow: 'autoRenewSignUpFlow',
    ProductUserFlow: 'productUserFlow',
    AboLedFlow: 'aboLedFlow',
    SelfInitiatedFlowMultiStep: 'selfInitiatedFlowMultiStep',
    GuestCheckoutFlow: 'guestCheckoutFlow',
    OpsLedFlow: 'opsLedFlow',
    SelfInitiatedMobileFlow: 'selfInitiatedMobileFlow'
} as const;
export type RegFlowConfig = typeof RegFlowConfig[keyof typeof RegFlowConfig];


export function RegFlowConfigFromJSON(json: any): RegFlowConfig {
    return RegFlowConfigFromJSONTyped(json, false);
}

export function RegFlowConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegFlowConfig {
    return json as RegFlowConfig;
}

export function RegFlowConfigToJSON(value?: RegFlowConfig | null): any {
    return value as any;
}

